import { DataMapper } from './transport';
import { Loader } from '@googlemaps/js-api-loader';
import Config from '../domain/entities/Config';
import { IGoogleMapsResponse } from './IDataMappings';

interface IGoogleMapsApiConfig {
  config: Config;
  dataMapper: DataMapper;
}

export default class GoogleMapsApi {
  config: Config;

  dataMapper: DataMapper;

  constructor({ config, dataMapper }: IGoogleMapsApiConfig) {
    this.dataMapper = dataMapper;
    this.config = config;
  }

  initLoader = (): Loader => {
    const { googleMapsKey } = this.config;
    const loader = new Loader({
      apiKey: googleMapsKey,
    });

    return loader;
  };

  getCoordinatesFromAddress = async (address: string): Promise<IGoogleMapsResponse> => {
    const google = await this.initLoader().load();
    const response = await new google.maps.Geocoder().geocode({ address });

    return this.dataMapper.mapResponse('googleApiMapper', response.results) as IGoogleMapsResponse;
  };
}
